// extracted by mini-css-extract-plugin
export default {"turmas":"UsuarioTurmas_turmas__lq7x9","turma":"UsuarioTurmas_turma__22dDG"};